import React from 'react';
import PropTypes from 'prop-types';

import {
  NlpContent,
  SheetContent,
  RoutingContent,
  EndpointContent,
  LiveChatContent,
  AutomatedContent,
  FailedJobContent,
  GenerativeAiContent,
  InactiveChatContent,
  SemanticSearchContent
} from './Content/index';

const types = {
  nlp: NlpContent,
  sso: NlpContent,
  debug: NlpContent,
  email: NlpContent,
  routing: RoutingContent,
  endpoint: EndpointContent,
  spreadsheet: SheetContent,
  live_chat: LiveChatContent,
  automation: AutomatedContent,
  generative_ai: GenerativeAiContent,
  inactive_chat: InactiveChatContent,
  semantic_search: SemanticSearchContent,
  failed_job: FailedJobContent,
};

const LogContent = ({ log }) => {
  if (!log) {
    return null;
  }

  const Content = types[log.type];

  return <Content {...log} />;
};

LogContent.propTypes = {
  log: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.oneOf(Object.keys(types)).isRequired
  })
};

export default LogContent;
